export default "__VITE_ASSET__DLJ1IgQw__"